import { useAtomValue } from 'jotai';
import { LineChartData } from '../../../types';
import { selectedViewDatePFJ } from '../state/PageStateJ';
import { IMetricsDataModel } from '../../../data-models/metrics.data-model';
import { earliestOf, isValidDate, plainDateToZonedDateTime } from '../../../util/date-utilts';
import { QuartersBuilder } from '../services/QuartersBuilder';
import { cumulativeQuarterSeries } from '../services/cumulativeQuarterSeries';

export const useNumberOfRoundsOverTime = (filteredData: IMetricsDataModel[]): LineChartData[] => {
  const date = useAtomValue(selectedViewDatePFJ);

  return computeNumberOfRoundsOverTime(date || new Date(), filteredData);
};

export function computeNumberOfRoundsOverTime(date: Date, filteredData: IMetricsDataModel[]) {
  const participatingDates = (filteredData ?? [])
    .flatMap(({ transactions }) => transactions ?? [])
    .filter(({ transactionDate, investmentAmount }) => !!transactionDate && investmentAmount !== 0)
    // Transaction dates are calendar dates; `new Date` would read them as UTC midnight and
    // shift a quarter-start date into the previous quarter west of Greenwich.
    .map(({ transactionDate }) => plainDateToZonedDateTime(transactionDate))
    .filter(isValidDate);

  return cumulativeQuarterSeries(
    participatingDates.map((d) => ({ date: d, value: 1 })),
    QuartersBuilder.axisQuartersSince(earliestOf(participatingDates), date),
    'Number of Rounds'
  );
}
